import {useState, useEffect} from 'react';
import API from '../../APIs/API';
import {CircularProgress, Box, Grid, Button, Fab, makeStyles} from '@material-ui/core';
import AgentInfo from './AgentInfo';
import {Add} from '@material-ui/icons';
import AddAgentModal from './Modals/AddAgentModal';
import DeleteAgentModal from './Modals/DeleteAgentModal';
import {observer} from 'mobx-react-lite';
type agent = {
    firstName: string;
    lastName: string;
    email: string;
};

const useStyles = makeStyles((theme) => ({
    container: {
        backgroundColor: theme.palette.background.paper,
    },
}));

export default observer(function EditXfers() {
    const [agentList, setAgentList] = useState([] as agent[]);
    const [loading, setLoading] = useState(true);
    const [addModal, setAddModal] = useState(false); // represent the visiblity of the modal
    const [deleteModal, setDeleteModal] = useState(false); // represent the visiblity of the modal
    const [load, setLoad] = useState(true);
    const [deleteAgent, setDeleteAgent] = useState({} as agent);
    const classes = useStyles();

    useEffect(() => {
        (async () => {
            let resp = await API.Call<agent[]>('agents');
            if (!resp) {
                setLoading(false);
                throw new Error('Failed to load agents');
            }
            resp = resp.map((item: any) => item.v);
            setAgentList(resp);
            setLoading(false);
        })();
    }, [load]);
    return (
        <Grid container justify="center">
            <Grid item xs={12}>
                {loading && <CircularProgress />}
                {agentList.map((item: agent, index: number) => (
                    <AgentInfo
                        {...item}
                        key={null}
                        handleDelete={() => {
                            setDeleteModal(true);
                            setDeleteAgent({...item});
                        }}
                    />
                ))}
            </Grid>
            {!loading && (
                <Grid item xs={12} justify="flex-end" style={{display: 'flex', margin: '12px 0'}}>
                    <Fab color="primary" aria-label="add" onClick={() => setAddModal(true)}>
                        <Add />
                    </Fab>
                </Grid>
            )}
            <AddAgentModal open={addModal} handleClose={() => setAddModal(false)} load={setLoad} />
            <DeleteAgentModal
                open={deleteModal}
                handleClose={() => setDeleteModal(false)}
                load={setLoad}
                agent={deleteAgent}
            />
        </Grid>
    );
});
